import React from 'react';
import Footer from "../../../navigation/footerContainer";
import AddPropertyContainer from './addProperty'

export default function AddPropertyPage() {
    return(
        <>
            <AddPropertyContainer />
            <Footer />
      
        </>

    )

}